<template>
  <span class="o-playlist__stats">
    <span v-if="isNew" class="o-playlist__textLabel o-playlist__movement--new">Nieuw</span>
    <span v-else-if="isReEntry" class="o-playlist__textLabel o-playlist__movement--reentry">Reentry</span>
    <template v-else>
      <span class="o-playlist__previous">{{stats.previousPosition}}</span> | 
      <strong class="o-playlist__movement" :class="styleClass">
        <SvgIcon :icon="icon" small /> {{display}}
      </strong>
    </template>
  </span>
</template>

<script>
export default {
  name: 'HitlistMovement',
  props: ['stats', 'position'],
  computed: {
    isNew() {
      return this.stats.timesInList == 1 || (!this.stats.timesInList && !this.stats.previousPosition) // Bug in database?
    },
    isReEntry() {
      return this.stats.timesInList > 1 && !this.stats.previousPosition
    },
    movement() {
      return this.stats.previousPosition - this.position
    },
    display() {
      if (this.movement == 0) { return }
      return Math.abs(this.movement)
    },
    rootClass() {
      if (this.isNew) {
        return 'o-playlist__movement--new'
      }
      return ''
    },
    styleClass() {
      switch (Math.sign(this.movement)) {
        case -1:
          return 'o-playlist__movement--dropped'
        case 1:
          return 'o-playlist__movement--raised'
        default:
          return 'o-playlist__movement--equal'
      }
    },
    icon() {
      if (this.movement == 0) { return 'hitlist-equal' }
      else                    { return 'hitlist-arrow' }
    }
  }
}
</script>

<style>

</style>